function announceError(message) {
  const status = document.getElementById('global-status');

  if (status) {
    status.textContent = message;
  }
}

export function initErrorBoundary() {
  window.addEventListener('error', () => {
    announceError('Ocurrió un problema inesperado. La navegación y las descargas siguen disponibles.');
  });

  window.addEventListener('unhandledrejection', (event) => {
    event.preventDefault();
    announceError('No se pudo completar una acción. Inténtalo nuevamente.');
  });
}
